module.exports = __webpack_public_path__ + "media/newstyle/images/icon-livrariacultura-2fa17fe55828eb3abdf5bd0ad0044952.svg";